// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecommendListing-container-_LFdO {
    margin: 0 auto;
    max-width: 1274px;
    padding: 0 24px;
}

.RecommendListing-pageContainer-gQO6C {
    padding-top: 48px;
}

.RecommendListing-displayGrid-j0NMn {
    display: grid;
    grid-template-columns: 24% 24% 24% 24%;
    grid-gap: 25px;
    margin: 0px 6px;
}

.RecommendListing-containerTitle-oVTQ3 {
    color: var(--common-text-color);
    margin: 0 0 35px;
    font-weight: bold;
    font-size: 36px;
    text-align: center;
}

.RecommendListing-recommandBg-VTmux {
    background-color: #F5FAFB;
    padding: 60px 0;
}

@media screen and (max-width: 1170px) {
    .RecommendListing-containerTitle-oVTQ3 {
        text-align: center;
    }
}

@media (max-width:1200px) and (min-width:992px) {
    .RecommendListing-displayGrid-j0NMn {
        grid-template-columns: auto auto auto;
        grid-gap: inherit;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
    }
}

@media (max-width:991px) and (min-width:768px) {
    .RecommendListing-displayGrid-j0NMn {
        grid-template-columns: 223px 223px 223px;
        grid-gap: 25px;
        margin: 0;
    }
}

@media (max-width:767px) {
    .RecommendListing-displayGrid-j0NMn {
        grid-template-columns: 100%;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        margin: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/RecommendListing/RecommendListing.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,iBAAiB;QACjB,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,wCAAwC;QACxC,cAAc;QACd,SAAS;IACb;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;QACvB,SAAS;IACb;AACJ","sourcesContent":[".container {\n    margin: 0 auto;\n    max-width: 1274px;\n    padding: 0 24px;\n}\n\n.pageContainer {\n    padding-top: 48px;\n}\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 24% 24% 24% 24%;\n    grid-gap: 25px;\n    margin: 0px 6px;\n}\n\n.containerTitle {\n    color: var(--common-text-color);\n    margin: 0 0 35px;\n    font-weight: bold;\n    font-size: 36px;\n    text-align: center;\n}\n\n.recommandBg {\n    background-color: #F5FAFB;\n    padding: 60px 0;\n}\n\n@media screen and (max-width: 1170px) {\n    .containerTitle {\n        text-align: center;\n    }\n}\n\n@media (max-width:1200px) and (min-width:992px) {\n    .displayGrid {\n        grid-template-columns: auto auto auto;\n        grid-gap: inherit;\n        justify-content: center;\n    }\n}\n\n@media (max-width:991px) and (min-width:768px) {\n    .displayGrid {\n        grid-template-columns: 223px 223px 223px;\n        grid-gap: 25px;\n        margin: 0;\n    }\n}\n\n@media (max-width:767px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n        justify-content: center;\n        margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RecommendListing-container-_LFdO`,
	"pageContainer": `RecommendListing-pageContainer-gQO6C`,
	"displayGrid": `RecommendListing-displayGrid-j0NMn`,
	"containerTitle": `RecommendListing-containerTitle-oVTQ3`,
	"recommandBg": `RecommendListing-recommandBg-VTmux`
};
module.exports = ___CSS_LOADER_EXPORT___;
